import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-vertical",
  templateUrl: "./med-icon-border-vertical.component.html",
})
export class MedIconBorderVerticalComponent extends SvgMixinComponent {}
